import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import Checkbox from '@precis-digital/kurama/Checkbox';
import Tooltip from '@precis-digital/kurama/Tooltip';
import type { ChartCardTFunction, ChartDataRow } from '../../../types';
import type { ChartCardTable } from '../tanstack';
interface TableHeadCellRowSelectionProps<DataKey extends string, DataRow extends ChartDataRow<DataKey>> {
  table: ChartCardTable<DataKey, DataRow>;
  some: boolean;
  all: boolean;
  t: ChartCardTFunction;
}
const TableHeadCellRowSelection = t0 => {
  const $ = _c(12);
  const {
    table,
    some,
    all,
    t
  } = t0;
  const title = all ? "selectNoneRows" : "selectAllRows";
  let t1;
  if ($[0] !== t || $[1] !== title) {
    t1 = t(title);
    $[0] = t;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = some && !all;
  let t3;
  if ($[3] !== table) {
    t3 = table.getToggleAllRowsSelectedHandler();
    $[3] = table;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== all || $[6] !== t2 || $[7] !== t3) {
    t4 = <Checkbox checked={all} indeterminate={t2} onChange={t3} />;
    $[5] = all;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <Tooltip kind="singleline" title={t1}>{t4}</Tooltip>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default TableHeadCellRowSelection;